import ToggleOptionElement from '@/components/ui/DatatableElements/ToggleOptionElement'
import DeleteElement from '@/components/ui/DatatableElements/DeleteElement'
import EditElement from '@/components/ui/DatatableElements/EditElement'
import Datatable from '@/components/ui/Datatable'
import SimpleTable from '@/components/ui/SimpleTable'
import Sortable from '@/components/ui/Sortable'
import Mailbox from '@/components/ui/Mailbox'
import MailboxBudget from '@/components/ui/MailboxBudget'
import Forms from '@/components/forms'
import config from '@/../config'

export const sysUsers = {
  name: 'Usuários (Manager)',
  key: 'sys-users',
  url: '/system/users',
  export: true,
  exportOptions: {
    searchAll: {
      params: {
        _onepage: true,
        _order: 'created_at:desc',
        '_scope[]': 'onlyOnManager',
        _filter: 'email;name;created_at'
      }
    },
    omit: ['address', 'main_role', 'activated'],
    name: 'usuarios',
    nameAll: 'usuarios',
    type: 'xls'
  },
  form: Forms.System.User,
  formOptions: {
    api: {
      params: {
        with: ['roles']
      }
    },
    'omit': ['address.city', 'first_name', 'last_name']
  },
  indexComponent: Datatable,
  sort: 'id:desc',
  tableOptions: {
    with: [''],
    scopes: ['onlyOnManager'],
    fields: [
      {
        label: '',
        key: 'status',
        component: ToggleOptionElement,
        style: 'width: 30px;'
      },
      {
        label: 'Nome',
        key: 'name',
        sortable: true,
        class: 'nightwatch-search'
      },
      {
        label: 'Email',
        key: 'email',
        sortable: true
      },
      {
        label: 'Perfil',
        key: 'main_role.name'
      },
      {
        label: 'Dias Logados',
        key: 'days_logged',
        sortable: true
      }
    ],
    actions: [
      { component: EditElement },
      { component: DeleteElement }
    ]
  }
}

export const generalBanners = {
  name: 'Home - Destaque',
  form: Forms.General.Banner,
  url: '/general/banners',
  key: 'general-banners',
  indexComponent: Datatable,
  sort: 'id:desc',
  // order: '/#/general-banners-order/',
  formOptions: {
    api: {
      params: {
        with: ['main', 'mobile'],
        scopes: ['home']
      }
    }
  },
  tableOptions: {
    with: ['main', 'mobile'],
    scopes: ['home'],
    fields: [
      {
        label: '',
        key: 'status',
        component: ToggleOptionElement,
        style: 'width: 10%;'
      },
      {
        label: 'Título',
        key: 'heading',
        sortable: true,
        style: 'width: 50%;',
        class: 'nightwatch-search'
      },
      {
        label: 'Data de atualização',
        key: 'updated_at',
        sortable: true,
        style: 'width: 10%;',
        formatters: [{
          type: 'date',
          args: 'DD/MM/YYYY'
        }]
      }
    ]
  }
}

export const generalOtherBanners = {
  name: 'Home - Área Genérica',
  form: Forms.General.OtherBanner,
  url: '/general/banners',
  key: 'general-other-banners',
  indexComponent: Datatable,
  sort: 'id:desc',
  // order: '/#/general-other-banners-order/',
  formOptions: {
    api: {
      params: {
        with: ['main', 'mobile'],
        scopes: ['generic']
      }
    }
  },
  tableOptions: {
    with: ['main', 'mobile'],
    scopes: ['generic'],
    fields: [
      {
        label: '',
        key: 'status',
        component: ToggleOptionElement,
        style: 'width: 10%;'
      },
      {
        label: 'Título',
        key: 'heading',
        sortable: true,
        style: 'width: 50%;',
        class: 'nightwatch-search'
      },
      {
        label: 'Data de atualização',
        key: 'updated_at',
        sortable: true,
        style: 'width: 10%;',
        formatters: [{
          type: 'date',
          args: 'DD/MM/YYYY'
        }]
      }
    ]
  }
}

export const generalBannersOrder = {
  name: 'Banners - Home',
  form: Forms.General.Banner,
  url: '/general/banners',
  key: 'general-banners',
  indexComponent: Sortable,
  options: {
    component: Forms.General.BannerCard,
    name: 'Banners - Home',
    search: ['status:1'],
    scopes: ['home']
  }
}

export const generalOtherBannersOrder = {
  name: 'Banners - Área Genérica',
  form: Forms.General.OtherBanner,
  url: '/general/banners',
  key: 'general-other-banners',
  indexComponent: Sortable,
  options: {
    component: Forms.General.BannerCard,
    name: 'Banners - Área Genérica',
    search: ['status:1'],
    scopes: ['generic']
  }
}

export const generalContacts = {
  name: 'Contatos',
  url: '/general/contacts',
  key: 'general-contacts',
  create: false,
  indexComponent: Mailbox,
  indexOptions: {
    attachments: true,
    multipleAttachments: true,
    orderBy: 'created_at:desc',
    read: 'status',
    with: ['attachments.file', 'address', 'subject']
  },
  filters: [
    {
      label: 'Lidos',
      icon: 'fa fa-envelope-open-o',
      params: ['status:1']
    },
    {
      label: 'Não lidos',
      icon: 'fa fa-envelope',
      params: ['status:0']
    }
  ]
}

export const generalBudgets = {
  name: 'Orçamentos',
  url: '/general/budgets',
  key: 'general-budgets',
  create: false,
  indexComponent: MailboxBudget,
  indexOptions: {
    attachments: true,
    multipleAttachments: true,
    orderBy: 'created_at:desc',
    read: 'status',
    with: ['address', 'product']
  },
  filters: [
    {
      label: 'Lidos',
      icon: 'fa fa-envelope-open-o',
      params: ['status:1']
    },
    {
      label: 'Não lidos',
      icon: 'fa fa-envelope',
      params: ['status:0']
    }
  ]
}

export const BudgetsExport = {
  name: 'Exportar XLS',
  key: 'budget-export',
  url: '/budget-export',
  form: Forms.Rte.BudgetsExport,
  indexComponent: SimpleTable,
  paginate: false,
  create: false,
  report: true,
  report_link: config.local.API_URL.replace(/"(.*)"/, '$1') + '/web/budget/export'
}

export const rtePartnerInsuranceCompanies = {
  name: 'Seguradoras Parceiras',
  key: 'rte-partner-insurance-companies',
  url: '/rte/partner-insurance-companies',
  create: true,
  form: Forms.Rte.PartnerInsuranceCompany,
  formOptions: {
    api: {
      params: {
        with: ['picture', 'media']
      }
    },
    'omit': []
  },
  indexComponent: Datatable,
  sort: 'id:desc',
  order: '/#/rte-partner-insurance-companies-order/',
  tableOptions: {
    with: ['picture', 'media'],
    scopes: [],
    fields: [
      {
        label: '',
        key: 'status',
        component: ToggleOptionElement,
        style: 'width: 30px;'
      },
      {
        label: '',
        key: 'highlight',
        component: ToggleOptionElement,
        props: {
          labels: ['Destaque', 'Não é destaque'],
          classes: ['fa fa-star', 'fa fa-star-o'],
          colors: ['#d39e00', 'gray']
        },
        style: 'width: 25px;'
      },
      {
        label: 'Título',
        key: 'title',
        sortable: true
      },
      {
        label: 'Data de atualização',
        key: 'updated_at',
        sortable: true,
        style: 'width: 10%;',
        formatters: [{
          type: 'date',
          args: 'DD/MM/YYYY'
        }]
      }
    ],
    actions: [
      { component: EditElement },
      { component: DeleteElement }
    ]
  }
}

export const rtePartnerInsuranceCompaniesOrder = {
  name: 'Seguradoras Parceiras',
  key: 'rte-partner-insurance-companies',
  url: '/rte/partner-insurance-companies',
  form: Forms.Rte.PartnerInsuranceCompany,
  indexComponent: Sortable,
  options: {
    component: Forms.Rte.PartnerInsuranceCompanyCard,
    name: 'Seguradoras Parceiras',
    search: ['status:1']
  }
}

export const rteGroupCompanies = {
  name: 'Empresas do Grupo',
  key: 'rte-group-companies',
  url: '/rte/group-companies',
  create: true,
  form: Forms.Rte.GroupCompany,
  formOptions: {
    api: {
      params: {
        with: ['picture', 'media']
      }
    },
    'omit': []
  },
  indexComponent: Datatable,
  sort: 'id:desc',
  order: '/#/rte-group-companies-order/',
  tableOptions: {
    with: [],
    scopes: [],
    fields: [
      {
        label: '',
        key: 'status',
        component: ToggleOptionElement,
        style: 'width: 30px;'
      },
      {
        label: '',
        key: 'highlight',
        component: ToggleOptionElement,
        props: {
          labels: ['Destaque', 'Não é destaque'],
          classes: ['fa fa-star', 'fa fa-star-o'],
          colors: ['#d39e00', 'gray']
        },
        style: 'width: 25px;'
      },
      {
        label: 'Título',
        key: 'title',
        sortable: true
      },
      {
        label: 'Data de atualização',
        key: 'updated_at',
        sortable: true,
        style: 'width: 10%;',
        formatters: [{
          type: 'date',
          args: 'DD/MM/YYYY'
        }]
      }
    ],
    actions: [
      { component: EditElement },
      { component: DeleteElement }
    ]
  }
}

export const rteCustomer = {
  singlePage: true,
  name: 'Importar Clientes',
  key: 'rte-customers',
  url: '/rte/customers',
  form: Forms.Rte.Customer,
  indexComponent: false
}

export const rteSortitionParticipants = {
  name: 'Participantes do Sorteio',
  key: 'rte-sortition-participants',
  url: '/rte/sortition-participants',
  form: Forms.Rte.SortitionParticipants,
  indexComponent: Datatable,
  sort: 'id:desc',
  hiddenAction: true,
  removeEdit: true,
  create: false,
  report: true,
  report_link: config.local.API_URL.replace(/"(.*)"/, '$1') + '/web/sortition/export',
  tableOptions: {
    with: [],
    scopes: [],
    fields: [
      {
        label: 'Nome',
        key: 'name',
        sortable: true
      },
      {
        label: 'E-mail',
        key: 'email',
        sortable: true
      },
      {
        label: 'CPF/CNPJ',
        key: 'document',
        sortable: true
      }
    ]
  }
}

export const rteGroupCompaniesOrder = {
  name: 'Empresas Parceiras',
  key: 'rte-group-companies',
  url: '/rte/group-companies',
  form: Forms.Rte.GroupCompany,
  indexComponent: Sortable,
  options: {
    component: Forms.Rte.GroupCompanyCard,
    name: 'Empresas Parceiras',
    search: ['status:1']
  }
}

export const rteSubjects = {
  name: 'Assuntos',
  key: 'rte-subjects',
  url: '/rte/subjects',
  create: true,
  form: Forms.Rte.Subject,
  formOptions: {
    api: {
      params: {
        with: []
      }
    },
    'omit': []
  },
  indexComponent: Datatable,
  sort: 'id:desc',
  order: '/#/rte-subjects-order/',
  tableOptions: {
    with: [],
    scopes: [],
    fields: [
      {
        label: '',
        key: 'status',
        component: ToggleOptionElement,
        style: 'width: 30px;'
      },
      {
        label: 'Título',
        key: 'name',
        sortable: true
      },
      {
        label: 'Data de atualização',
        key: 'updated_at',
        sortable: true,
        style: 'width: 10%;',
        formatters: [{
          type: 'date',
          args: 'DD/MM/YYYY'
        }]
      }
    ],
    actions: [
      { component: EditElement },
      { component: DeleteElement }
    ]
  }
}

export const rteCampaign = {
  name: 'Leads Campanha de Divulgação',
  key: 'rte-campaign',
  url: '/rte/campaign',
  create: false,
  report: true,
  report_link: config.local.API_URL.replace(/"(.*)"/, '$1') + '/web/campaign/export',
  form: Forms.Rte.Campaign,
  formOptions: {
    api: {
      params: {
        with: []
      }
    },
    'omit': []
  },
  indexComponent: Datatable,
  sort: 'id:desc',
  tableOptions: {
    with: [],
    scopes: [],
    fields: [
      {
        label: 'Nome',
        key: 'name',
        sortable: true
      },
      {
        label: 'Email',
        key: 'email',
        sortable: true
      },
      {
        label: 'Telefone',
        key: 'phone',
        sortable: true
      },
      {
        label: 'Seguro',
        key: 'insurance_im_interested',
        sortable: true
      },
      {
        label: 'Data',
        key: 'updated_at',
        sortable: true,
        style: 'width: 10%;',
        formatters: [{
          type: 'date',
          args: 'DD/MM/YYYY HH:mm'
        }]
      }
    ],
    actions: [
      { component: EditElement },
      { component: DeleteElement }
    ]
  }
}

export const rteSubjectsOrder = {
  name: 'Assuntos',
  key: 'rte-subjects',
  url: '/rte/subjects',
  form: Forms.Rte.Subject,
  indexComponent: Sortable,
  options: {
    component: Forms.Rte.SubjectCard,
    name: 'Assuntos',
    search: ['status:1']
  }
}

export const rteProducts = {
  name: 'Produtos',
  key: 'rte-products',
  url: '/rte/products',
  create: true,
  form: Forms.Rte.Product,
  formOptions: {
    api: {
      params: {
        with: []
      }
    },
    'omit': []
  },
  indexComponent: Datatable,
  sort: 'id:desc',
  order: '/#/rte-products-order/',
  tableOptions: {
    with: [],
    scopes: [],
    fields: [
      {
        label: '',
        key: 'status',
        component: ToggleOptionElement,
        style: 'width: 30px;'
      },
      {
        label: '',
        key: 'highlight',
        component: ToggleOptionElement,
        props: {
          labels: ['Destaque', 'Não é destaque'],
          classes: ['fa fa-star', 'fa fa-star-o'],
          colors: ['#d39e00', 'gray']
        },
        style: 'width: 25px;'
      },
      {
        label: 'Título',
        key: 'title',
        sortable: true,
        style: 'width: 70%;'
      },
      {
        label: 'Data de atualização',
        key: 'updated_at',
        sortable: true,
        style: 'width: 10%;',
        formatters: [{
          type: 'date',
          args: 'DD/MM/YYYY'
        }]
      }
    ],
    actions: [
      { component: EditElement },
      { component: DeleteElement }
    ]
  }
}

export const rteProductsOrder = {
  name: 'Produtos',
  key: 'rte-products',
  url: '/rte/products',
  form: Forms.Rte.Product,
  indexComponent: Sortable,
  options: {
    component: Forms.Rte.ProductCard,
    name: 'Produtos',
    search: ['status:1']
  }
}

export const generalPopups = {
  name: 'Popups - Home',
  form: Forms.General.Popup,
  url: '/general/popups',
  key: 'general-popups',
  indexComponent: Datatable,
  sort: 'id:desc',
  // order: '/#/general-popups-order/',
  formOptions: {
    api: {
      params: {
        with: ['main', 'mobile'],
        scopes: ['home']
      }
    }
  },
  tableOptions: {
    with: ['main', 'mobile'],
    scopes: ['home'],
    fields: [
      {
        label: '',
        key: 'status',
        component: ToggleOptionElement,
        style: 'width: 10%;'
      },
      {
        label: 'Título',
        key: 'heading',
        sortable: true,
        style: 'width: 50%;',
        class: 'text-ellipsis nightwatch-search'
      },
      {
        label: 'Data de atualização',
        key: 'updated_at',
        sortable: true,
        style: 'width: 10%;',
        formatters: [{
          type: 'date',
          args: 'DD/MM/YYYY'
        }]
      }
    ]
  }
}

export const generalPopupsOrder = {
  name: 'Popups - Home',
  form: Forms.General.Popup,
  url: '/general/popups',
  key: 'general-popups',
  indexComponent: Sortable,
  options: {
    component: Forms.General.BannerCard,
    name: 'Popups - Home',
    search: ['status:1'],
    scopes: ['home']
  }
}

export default {
  'sys-users': sysUsers,
  'general-banners': generalBanners,
  'general-other-banners': generalOtherBanners,
  'general-banners-order': generalBannersOrder,
  'general-other-banners-order': generalOtherBannersOrder,
  'general-contacts': generalContacts,
  'general-budgets': generalBudgets,
  'budget-export': BudgetsExport,
  'rte-partner-insurance-companies': rtePartnerInsuranceCompanies,
  'rte-partner-insurance-companies-order': rtePartnerInsuranceCompaniesOrder,
  'rte-group-companies': rteGroupCompanies,
  'rte-group-companies-order': rteGroupCompaniesOrder,
  'rte-customer': rteCustomer,
  'rte-sortition-participants': rteSortitionParticipants,
  'rte-subjects': rteSubjects,
  'rte-subjects-order': rteSubjectsOrder,
  'rte-products': rteProducts,
  'rte-products-order': rteProductsOrder,
  'general-popups': generalPopups,
  'general-popups-order': generalPopupsOrder,
  'rte-campaign': rteCampaign
}



// WEBPACK FOOTER //
// ./src/_entities.js